import React, {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {Card, CardBody, Row, Col, Button} from "reactstrap";
import ReactGA from "react-ga4";
import {BackgroundColorContext} from "../contexts/BackgroundColorContext";
import {GoogleAnalyticsEventCategories} from "../constants";
import PageHeader from "../components/Common/PageHeader";

const PurchaseCancel: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Track purchase cancellation page view
    ReactGA.event({
      category: GoogleAnalyticsEventCategories.PAYMENT,
      action: "purchase cancel page viewed",
      label: "payment cancelled by user"
    });
  }, []);

  return (
    <BackgroundColorContext.Consumer>
      {({color}) => (
        <>
          <PageHeader
            title="Payment Cancelled"
            subtitle="Your purchase was not completed"
            icon="fa fa-times-circle text-warning"
          />
          <Row>
            <Col md="12">
              <Card>
                <CardBody>
                  <div className="text-center">
                    <i className="fa fa-times-circle fa-5x text-warning mb-4" />
                    <h4>Your payment was cancelled</h4>
                    <p className="lead">No charges have been made to your account.</p>
                    <p className="text-muted">
                      You can return to the purchase page to try again, or continue using your free monthly tokens.
                    </p>
                    <div className="mt-4">
                      <Button
                        color="primary"
                        data-color={color}
                        size="lg"
                        onClick={() => {
                          // Track return to purchase from cancel page
                          ReactGA.event({
                            category: GoogleAnalyticsEventCategories.PAYMENT,
                            action: "back to purchase from cancel page",
                            label: "retry payment attempt"
                          });
                          navigate("/tokens/purchase");
                        }}
                      >
                        <i className="fa fa-credit-card mr-2" />
                        Back to Purchase
                      </Button>
                      <Button
                        color="secondary"
                        size="lg"
                        className="ml-2"
                        onClick={() => {
                          // Track continue with free tokens from cancel page
                          ReactGA.event({
                            category: GoogleAnalyticsEventCategories.PAYMENT,
                            action: "continue with free tokens from cancel page",
                            label: "skip payment"
                          });
                          navigate("/upload");
                        }}
                      >
                        <i className="fa fa-upload mr-2" />
                        Continue with Free Tokens
                      </Button>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </>
      )}
    </BackgroundColorContext.Consumer>
  );
};

export default PurchaseCancel;
